var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-geo-json',{key:"pipsol",attrs:{"geojson":_vm.pipelines,"options":_vm.geoJsonOptions,"optionsStyle":_vm.styleFunction,"name":"Tuberías","layer-type":"overlay","pane":"tilePane"}})}
var staticRenderFns = []

export { render, staticRenderFns }